// New accounts open only with a company address (toplantı 5 Kasım 2026): a work domain shows which brand or agency
// the application comes from. Existing accounts keep signing in with whatever address they have.
const PERSONAL = new Set([
  'gmail.com', 'googlemail.com',
  'hotmail.com', 'hotmail.com.tr', 'hotmail.co.uk', 'hotmail.de', 'hotmail.fr', 'outlook.com', 'outlook.com.tr', 'live.com', 'live.com.tr', 'msn.com', 'windowslive.com',
  'yahoo.com', 'yahoo.com.tr', 'yahoo.co.uk', 'yahoo.de', 'yahoo.fr', 'ymail.com', 'rocketmail.com',
  'icloud.com', 'me.com', 'mac.com', 'aol.com',
  'yandex.com', 'yandex.com.tr', 'yandex.ru', 'ya.ru', 'mail.ru', 'bk.ru', 'inbox.ru', 'list.ru',
  'gmx.com', 'gmx.de', 'gmx.net', 'web.de', 't-online.de',
  'proton.me', 'protonmail.com', 'pm.me', 'tutanota.com', 'tuta.io', 'zoho.com', 'hushmail.com', 'fastmail.com',
  'mynet.com', 'superonline.com', 'ttmail.com', 'turk.net', 'qq.com', '163.com',
  'mailinator.com', 'yopmail.com', 'guerrillamail.com', 'temp-mail.org', '10minutemail.com', 'sharklasers.com',
]);

export const emailDomain = email => String(email || '').trim().toLowerCase().split('@').pop() || '';
export const isPersonalEmail = email => PERSONAL.has(emailDomain(email));
export const PERSONAL_EMAIL_ERROR = 'Hesap şirket e-postasıyla açılır. Gmail, Hotmail gibi kişisel adreslerle hesap açılmıyor.';
